import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onMouseover"]
const _hoisted_2 = { class: "skill-name" }
const _hoisted_3 = { class: "skill-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_SkillsSubPanel = _resolveComponent("SkillsSubPanel")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "skills-container",
    title: "SKILLS"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.Skills), (skill) => {
        return (_openBlock(), _createElementBlock("div", {
          key: skill,
          class: _normalizeClass(["skill-wrapper", {
        'text-selected': skill === _ctx.state.ui.selectedSkill,
        'text-tagged': _ctx.state.build.Skills[skill].tagged,
        'text-disabled': skill === 'Scavenging',
      }]),
          onMouseover: ($event: any) => (_ctx.showInfo('Skills', skill))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_GenericButton, {
              text: _ctx.state.build.Skills[skill].name,
              variant: "text",
              class: "item-hover",
              onClick: ($event: any) => (_ctx.selectSkill(skill))
            }, null, 8, ["text", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.state.build.Skills[skill].value), 1),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "skill-percent" }, " % ", -1)),
          _createVNode(_component_Checkbox, {
            class: _normalizeClass({
          hidden: skill === 'Scavenging',
        }),
            onToggle: ($event: any) => (_ctx.selectSkill(skill)),
            checked: skill === _ctx.state.ui.selectedSkill
          }, null, 8, ["class", "onToggle", "checked"])
        ], 42, _hoisted_1))
      }), 128)),
      _createVNode(_component_SkillsSubPanel, { class: "mt-11" })
    ]),
    _: 1
  }))
}